module.exports = {
  id: 27,
  name: 'Bridge Holds',
  categories: ['strength', 'core', 'flexibility'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'intermediate',
  skill: 'Core',
  points: 12,
  instructions:
    'Bridge Holds make your bottom and core strong! Lie on your back with knees bent, lift your butt up off the ground like making a bridge, hold for a few seconds, then lower down. Keep your feet flat on the ground!',
  timedInstructions: [
    {
      time: 0,
      text: "You're building a bridge across a river! 3, 2, 1, START BUILDING!",
    },
    {
      time: 3,
      text: 'Lift the bridge up for cars to cross!',
    },
    {
      time: 5,
      text: 'Hold the bridge steady!',
    },
    {
      time: 7,
      text: 'Oh no! A dog walking a man is crossing!',
    },
    {
      time: 9,
      text: "Keep the bridge up, don't let them fall!",
    },
    {
      time: 11,
      text: 'Lower the bridge for boats to pass!',
    },
    {
      time: 13,
      text: 'Lift the bridge up for cars to cross!',
    },
    {
      time: 15,
      text: 'Hold the bridge steady!',
    },
    {
      time: 17,
      text: 'A clown car with 20 clowns is crossing!',
    },
    {
      time: 19,
      text: 'Keep the bridge strong, so many clowns!',
    },
    {
      time: 21,
      text: 'Lower the bridge for boats to pass!',
    },
    {
      time: 23,
      text: 'Lift the bridge up for cars to cross!',
    },
    {
      time: 25,
      text: 'Hold the bridge steady!',
    },
    {
      time: 27,
      text: 'A pizza delivery truck is in a hurry!',
    },
    {
      time: 29,
      text: 'Keep the bridge up, the pizza is getting cold!',
    },
    {
      time: 31,
      text: 'Lower the bridge for boats to pass!',
    },
    // REST PERIOD 1 - 15 seconds
    {
      time: 33,
      text: 'Amazing job! Take a good break now',
    },
    {
      time: 36,
      text: 'Breathe in and out, catch your breath',
    },
    {
      time: 39,
      text: "You just did 6 bridge holds, that's incredible!",
    },
    {
      time: 42,
      text: 'Your core and bottom are getting so strong!',
    },
    {
      time: 45,
      text: 'Remember to keep your feet flat on the ground',
    },
    {
      time: 48,
      text: 'Keep your body in a straight line',
    },
    {
      time: 51,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 54,
      text: "You're building amazing bridge strength!",
    },
    {
      time: 57,
      text: 'Ready for round two, bridge builder!',
    },
    {
      time: 60,
      text: '3, 2, 1, KEEP BUILDING!',
    },
    {
      time: 45,
      text: 'Lift the bridge up for cars to cross!',
    },
    {
      time: 47,
      text: 'Hold the bridge steady!',
    },
    {
      time: 49,
      text: 'A marching band is crossing the bridge!',
    },
    {
      time: 51,
      text: "Keep the bridge strong, they're playing loud!",
    },
    {
      time: 53,
      text: 'Lower the bridge for boats to pass!',
    },
    {
      time: 55,
      text: 'Lift the bridge up for cars to cross!',
    },
    {
      time: 57,
      text: 'Hold the bridge steady!',
    },
    {
      time: 59,
      text: 'A cat driving a motorcycle is crossing!',
    },
    {
      time: 61,
      text: 'Keep the bridge up, that cat is brave!',
    },
    {
      time: 63,
      text: 'Lower the bridge for boats to pass!',
    },
    {
      time: 65,
      text: 'Lift the bridge up for cars to cross!',
    },
    {
      time: 67,
      text: 'Hold the bridge steady!',
    },
    {
      time: 69,
      text: 'A unicycle circus is crossing!',
    },
    {
      time: 71,
      text: "Keep the bridge strong, they're juggling!",
    },
    {
      time: 73,
      text: 'Lower the bridge for boats to pass!',
    },
    // REST PERIOD 2 - 15 seconds
    {
      time: 75,
      text: 'Amazing job! Take another break',
    },
    {
      time: 78,
      text: 'Breathe in and out, feel your strength',
    },
    {
      time: 81,
      text: 'You just did 12 bridge holds total!',
    },
    {
      time: 84,
      text: 'Your core and bottom are getting stronger!',
    },
    {
      time: 87,
      text: 'Remember to keep your feet flat on the ground',
    },
    {
      time: 90,
      text: 'Keep your body in a straight line',
    },
    {
      time: 93,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 96,
      text: "You're becoming a bridge building master!",
    },
    {
      time: 99,
      text: 'Ready for round three, bridge champion!',
    },
    {
      time: 102,
      text: '3, 2, 1, KEEP BUILDING!',
    },
    {
      time: 87,
      text: 'Lift the bridge up for cars to cross!',
    },
    {
      time: 89,
      text: 'Hold the bridge steady!',
    },
    {
      time: 91,
      text: 'A robot walking a pet dinosaur is crossing!',
    },
    {
      time: 93,
      text: "Keep the bridge up, that's a big dinosaur!",
    },
    {
      time: 95,
      text: 'Lower the bridge for boats to pass!',
    },
    {
      time: 97,
      text: 'Lift the bridge up for cars to cross!',
    },
    {
      time: 99,
      text: 'Hold the bridge steady!',
    },
    {
      time: 101,
      text: 'A superhero in pajamas is crossing!',
    },
    {
      time: 103,
      text: 'Keep the bridge strong, even superheroes need bridges!',
    },
    {
      time: 105,
      text: 'Lower the bridge for boats to pass!',
    },
    {
      time: 107,
      text: 'Lift the bridge up for cars to cross!',
    },
    {
      time: 109,
      text: 'Hold the bridge steady!',
    },
    {
      time: 111,
      text: 'A penguin on roller skates is crossing!',
    },
    {
      time: 113,
      text: 'Keep the bridge up, that penguin is fast!',
    },
    {
      time: 115,
      text: 'Lower the bridge for boats to pass!',
    },
    // REST PERIOD 3 - 15 seconds
    {
      time: 117,
      text: 'Amazing job! Take a final break and we will end this workout with a bridge to behold! The greatest bridge of all time!',
    },
    {
      time: 120,
      text: 'Breathe in and out, feel your strength come back to you.',
    },
    {
      time: 122,
      text: 'You just did 18 bridge holds total!',
    },
    {
      time: 125,
      text: 'Your core and bottom are incredibly strong!',
    },
    {
      time: 128,
      text: 'Remember to keep your feet flat on the ground',
    },
    {
      time: 131,
      text: 'Keep your body in a straight line',
    },
    {
      time: 134,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 137,
      text: "You're a bridge building superstar!",
    },
    {
      time: 140,
      text: 'Ready for the final round, bridge master!',
    },
    {
      time: 143,
      text: '3, 2, 1, FINAL BRIDGE!',
    },
    {
      time: 146,
      text: 'Lift the bridge up for cars to cross!',
    },
    {
      time: 148,
      text: 'Hold the bridge steady!',
    },
    {
      time: 150,
      text: 'A grandma driving a race car is crossing!',
    },
    {
      time: 152,
      text: "Keep the bridge up, she's going fast!",
    },
    {
      time: 154,
      text: 'Lower the bridge for boats to pass!',
    },
    {
      time: 156,
      text: 'Lift the bridge up for cars to cross!',
    },
    {
      time: 158,
      text: 'Hold the bridge steady!',
    },
    {
      time: 160,
      text: 'A giraffe in a convertible is crossing!',
    },
    {
      time: 162,
      text: "Keep the bridge strong, that's a tall car!",
    },
    {
      time: 164,
      text: 'Lower the bridge for boats to pass!',
    },
    {
      time: 166,
      text: 'Lift the bridge up for cars to cross!',
    },
    {
      time: 168,
      text: 'Hold the bridge steady!',
    },
    {
      time: 170,
      text: 'A mermaid is crossing in the river! Keep her safe!',
    },
    {
      time: 172,
      text: "Keep the bridge up, she's on land now!",
    },
    {
      time: 174,
      text: 'Lower the bridge for boats to pass!',
    },
    {
      time: 176,
      text: 'Final push, bridge master!',
    },
    {
      time: 178,
      text: 'Lift the bridge up for cars to cross!',
    },
    {
      time: 180,
      text: 'Hold the bridge steady!',
    },
    {
      time: 182,
      text: 'Keep the bridge strong!',
    },
    {
      time: 184,
      text: 'Stay strong, bridge builder!',
    },
    {
      time: 186,
      text: 'Lower the bridge for boats to pass!',
    },
    {
      time: 188,
      text: 'You did it, bridge champion!',
    },
    {
      time: 190,
      text: 'Incredible work! You did 24 bridge holds!',
    },
    {
      time: 192,
      text: 'Your core and bottom are incredibly strong!',
    },
    {
      time: 194,
      text: 'You are a bridge master!',
    },
  ],
};
